import api from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export async function getPushStatus() {
  try {
    const { data } = await api.get("/push/status");
    return data;
  } catch {
    return { enabled: false, count: 0, configured: false };
  }
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("Les notifications ne sont pas supportées sur cet appareil.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Autorisation refusée. Activez les notifications dans les réglages.");

  const reg = await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/public-key");
  if (!data.configured || !data.public_key) throw new Error("Notifications non configurées côté serveur.");

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    try {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(data.public_key),
      });
    } catch (err) {
      throw new Error("Impossible d'activer les notifications ici. Sur iPhone, installez d'abord l'app sur l'écran d'accueil.");
    }
  }
  await api.post("/push/subscribe", { subscription: sub.toJSON() });
  return true;
}

export async function disablePush() {
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (sub) {
      await api.post("/push/unsubscribe", { subscription: sub.toJSON() });
      await sub.unsubscribe();
    } else {
      await api.post("/push/unsubscribe", { subscription: {} });
    }
  } catch {
    /* best-effort */
  }
  return true;
}

export async function sendTestPush() {
  const { data } = await api.post("/push/test");
  return data;
}
